import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Skeleton, Card } from "antd";
import { LiaArrowRightSolid } from "react-icons/lia";
import { getUnitPaymentDetails } from "../../store/thunks/paymentThunks";
import StatCardGroup from "../../components/Common/StatCardGroup";
import Table from "../../components/Common/Table";
import Loader from "../../components/Common/Loader";

const ViewPaymentsPage = () => {
  const { unitId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { info, payments, loading, error } = useSelector(
    (s) => s.payment.unitPaymentDetails
  );

  useEffect(() => {
    if (unitId) dispatch(getUnitPaymentDetails(unitId));
  }, [unitId, dispatch]);

  const title = info
    ? `Payments · ${info.propertyName || "-"} · ${
        info.unitName || info.unitId || ""
      }`
    : "Payments";

   /* if (loading) {
      return (
        <div className="flex justify-center p-4 sm:p-6 md:p-[30px] font-inter">
          <div className="w-full lg:w-[1080px] xl:w-full">
            <Skeleton.Input active style={{ width: 300, height: 32 }} className="mb-6" />
            
            <Card className="mb-8">
              <Skeleton active paragraph={{ rows: 2 }} />
            </Card>
            
            <Skeleton active paragraph={{ rows: 6 }} />
          </div>
        </div>
      );
    }*/
  
    if (loading) {
      return (
        <div className="flex justify-center items-center absolute left-72 z-50 inset-0 ">
      <Loader color="#4772F1" />
      </div>

    );

    }

  if (!info) {
    return <div className="p-8 text-red-500">No tenant data found.</div>;
  }

  const tenantInfoCards = [
    { label: "Tenant Name", value: info?.tenantName || "None" },
    { label: "Property Name", value: info?.propertyName || "None" },
    { label: "Unit ID / Name", value: `${info?.unitId || ''} / ${info?.unitName || ''}`.trim() || "None" },
    { 
      label: "Monthly Rent", 
      value: info?.monthlyRent ? `UGX ${info.monthlyRent.toLocaleString()}` : "0" 
    },
    { 
      label: "Deposit Received", 
      value: info?.depositReceived ? `UGX ${info.depositReceived.toLocaleString()}` : "0" 
    },
    { label: "Paid-Through Date", value: info?.paidThroughDate ? new Date(info.paidThroughDate).toLocaleDateString() : "None" },
    { label: "Outstanding Days", value: info?.outstandingDays ? `${info.outstandingDays} days` : "None" },
  ];
  const columns = [
    { title: "Payment Date", dataIndex: "paymentDate", key: "date", render: (date) => date ? new Date(date).toLocaleDateString() : '-' },
    { title: "Amount Paid", dataIndex: "amount", key: "amount", render: (amount) => amount ? `${amount.toFixed(2)} UGX` : '-' },
    {
      title: "Covered Period",
      //dataIndex: "coveredPeriod",
      key: "coveredPeriod",
      render: (_, record) => (
        <span className="flex flex-row items-center gap-2">
          {record.rentCoveredFrom ? new Date(record.rentCoveredFrom).toLocaleDateString() : '-'} <LiaArrowRightSolid className="mx-1 mt-0" />
          {record.rentCoveredTo ? new Date(record.rentCoveredTo).toLocaleDateString() : '-'}
        </span>
      ),
    },
  ];

  return (
    <div className="flex justify-center p-4 sm:p-6 md:p-[30px] font-inter">
      <div className="w-full lg:w-[1080px] xl:w-full">
     {/* <h2 className="text-xl font-semibold">{title}</h2>*/}
       {/* <Button onClick={() => navigate(-1)}>Back</Button>*/}
        <div className="p-3 sm:p-5 md:p-6 lg:p-[30px] bg-white rounded-[10px] shadow-[0_4px_4px_0_#0000000F]">
          <StatCardGroup items={tenantInfoCards} />
        </div>

        <div className="mt-[30px]">
            <div className="w-full overflow-x-auto">
              <Table
            rowKey={(r, i) => `${r.paymentDate}-${r.amount}-${i}`}
                columns={columns}
                hasSubTable={false}
                dataSource={payments.map(payment => ({
              ...payment,
              key: payment.paymentDate
            }))}
            pagination={{ pageSize: 10 }}
            locale={{
              emptyText: loading ? "Loading..." : "No payments found",
            }}
              />
            </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPaymentsPage;
